<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Change Transportation for {{ config.data.passenger?.name }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <div class="flex flex-column gap-spacing-2xs">
    <h6 class="mb-0 label-large-medium text-primary-color">Time to Late Cancel</h6>
    <div class="countdown-card px-spacing-xs py-spacing-2xs flex align-items-center justify-content-around gap-spacing-md border-1 border-round-md bg-white border-neutral-base-primary-border">
      <div class="time hours flex flex-column align-items-center">
        <span class="title-small-bold text-help-color">{{ timeToLateCancel()?.hours }}</span>
        <span class="body-small-regular text-light-color">Hours</span>
      </div>
      <span class="vertical-line border-neutral-base-primary-bg"></span>
      <div class="time minutes flex flex-column align-items-center">
        <span class="title-small-bold text-help-color">{{ timeToLateCancel()?.minutes }}</span>
        <span class="body-small-regular text-light-color">Minutes</span>
      </div>
      <span class="vertical-line border-neutral-base-primary-bg"></span>
      <div class="time seconds flex flex-column align-items-center">
        <span class="title-small-bold text-help-color">{{ timeToLateCancel()?.seconds }}</span>
        <span class="body-small-regular text-light-color">Seconds</span>
      </div>
    </div>
  </div>

  <form
    #form="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label label-large-medium text-primary-color"
        for="reasonInput">
        Cancelation Type
      </label>
      <div class="form-group">
        @if (appSettings.hasChangeCancellationTypePermission) {
          <p-select
            [(ngModel)]="cancelTypeStatus"
            name="status"
            required
            [options]="statusOptions"
            optionLabel="name"
            placeholder="Select a cancelation type" />
        } @else {
          <span class="label-large-regular form-label-color px-spacing-md">{{cancelTypeStatus.name}}</span>
        }
      </div>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium text-secondary-color"
        for="reasonInput"
        >Reason
        <span class="body-small-medium text-caption-color">The reason for why you are updating this passenger's transportation status.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        inputStyleClass="px-spacing-md pt-spacing-md"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason."
        appendTo="body"
        [showEmptyMessage]="false" />
    </div>
  </form>
  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xs list-none">
      <li class="label-large-regular text-warning-color">This action will notify the driver and any monitors via push notification.</li>
    </ul>
  </div>
</div>

<div class="footer pb-spacing-3xl pt-spacing-4xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    label="Cancel Transportation"
    [isLoading]="loading"
    [disabled]="loading || !!form?.invalid || reasonInput.value?.trim().length <= 0"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction(form)"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
